// extracted by mini-css-extract-plugin
export default {"subTitulo":"SubTituloAss_subTitulo__c-vz7"};